<template>
  <view-wrapper
    prefix="Add new"
    name="Integration Client"
    path="integrationclients"
    :showCancel="true"
    :addedFunc="createIntegrationClient"
    :hasChangesBeenMade="hasChangesBeenMade"
    :loading="loading"
    :validation="validation"
  >
    <wrapper class="mb-5" :checkForChildFocused="true">
      <grafokett-input
        type="text"
        labelPlaceholder="Name"
        v-model="formData.name"
        :editable="true"
      />
      <grafokett-input
        type="text"
        labelPlaceholder="Description"
        v-model="formData.description"
        :editable="true"
      />
      <span class="text-xs text-white" v-if="selectedGroups.length > 0"
        >Default Groups</span
      >
      <multiselect
        v-model="selectedGroups"
        :options="groups"
        :multiple="true"
        :close-on-select="true"
        placeholder="Default Groups"
        label="name"
        track-by="id"
      />
    </wrapper>
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../../components/forms/Input.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    GrafokettInput,
    Multiselect,
  },
  data() {
    return {
      loading: false,
      formData: {
        name: null,
        description: "",
      },
      selectedGroups: [],
      groups: [],
    };
  },
  methods: {
    async getData() {
      const { data: groupsData } = await this.$store.$api.get("/api/groups");

      if (groupsData)
        this.groups = groupsData.data.map(({ id, name }) => ({
          id,
          name,
        }));
    },
    hasChangesBeenMade() {
      return Object.keys(this.formData).some(key => this.formData[key] !== "");
    },
    async createIntegrationClient() {
      this.loading = true;
      await this.$store.$api.post("/api/integrationclient", {
        ...this.formData,
        groupIds:
          this.selectedGroups && this.selectedGroups.length > 0
            ? this.selectedGroups.map(g => g.id)
            : [],
      });
      this.loading = false;
    },
    validation() {
      const { name } = this.formData;

      const value =
        name &&
        name.length &&
        name.length > 0 &&
        name.length <= 128 &&
        name !== "" &&
        name !== " ";

      return value || false;
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<style></style>
